
import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { Check, AlertCircle, Info, X, Heart } from "lucide-react"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, icon, ...props }) {
        // Default icons based on variant
        let defaultIcon = null
        if (!icon) {
          if (variant === "success") defaultIcon = <Check className="h-5 w-5 text-green-600" />
          else if (variant === "destructive") defaultIcon = <X className="h-5 w-5 text-red-600" />
          else if (variant === "warning") defaultIcon = <AlertCircle className="h-5 w-5 text-green-600" />
          else if (variant === "info") defaultIcon = <Info className="h-5 w-5 text-green-600" />
          else if (variant === "mint") defaultIcon = <Check className="h-5 w-5 text-green-600" />
          else if (variant === "save") defaultIcon = <Check className="h-5 w-5 text-green-600" />
          else defaultIcon = <Check className="h-5 w-5 text-green-600" />
        }
        
        const displayIcon = icon || defaultIcon

        return (
          <Toast key={id} variant={variant} icon={displayIcon} className="rounded-2xl" {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
